<template>
  <router-link v-if="userFullName" :to="{name: 'profile'}" class="user-block">
    <div class="user-block__icon">
      <icu-icon icon-name="pc-user" />
    </div>
    <div class="user-block__name">
      {{ userFullName }}
    </div>
  </router-link>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon'
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import IcuButton from '@/components/common/IcuButton'
import LanguageSwitcher from '@/components/common/LanguageSwitcher'
import { mapGetters } from 'vuex'
import {api} from '@/api/api'


export default {
  name: 'UserBlock',
  components: {LanguageSwitcher, IcuButton, ModalContainer, ModalWrapper, IcuIcon},
  data(){
    return {
      showLogout: false,
    }
  },
  computed: {
    ...mapGetters(['userFullName'])
  },
  methods: {
    logout(){
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped lang="scss">
.user-block {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &__name {
    padding: 0 15px;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
  }

  &__logout {
    cursor: pointer;
  }
  @media (max-width: 768px){
    padding-right: 15px;
  }
}

.logout-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.register-page__modal-logo {
  margin: 0;
}
.register-page__modal-buttons {
  padding-top: 0;
}

</style>
